module.exports = __webpack_public_path__ + "img/jwgl-pk-xzb.2b37828d.png";